import { isValidNumber } from '@/utils/isValidNumber';

interface FormatNumberOptions {
  desiredNumberOfLeadingZeros?: number;
  desiredNumberOfDecimals?: number;
  shouldInsertCommas?: boolean;
  includeSign?: boolean;
}

export function formatNumber(number: number, options: FormatNumberOptions = {}) {
  let { desiredNumberOfDecimals, desiredNumberOfLeadingZeros, shouldInsertCommas } = options;
  if (!isValidNumber(number)) {
    throw new Error(`Unable to format number - number argument is not a valid number: ${typeof number}, ${number}.`);
  }

  let stringNumber = `${Number(number)}`.trim();

  if (desiredNumberOfDecimals !== undefined) {
    if (!isValidNumber(desiredNumberOfDecimals, { isRequiredToBeInteger: true, isRequiredToBeGreaterThanOrEqualToZero: true })) {
      throw new Error(`Unable to format number - desiredNumberOfDecimals argument is not valid: ${typeof desiredNumberOfDecimals}, ${desiredNumberOfDecimals}.`);
    }

    stringNumber = Number(stringNumber).toFixed(Number(desiredNumberOfDecimals));
  }

  const isNegative = stringNumber.startsWith('-');

  if (isNegative) {
    stringNumber = stringNumber.slice(1);
  }

  if (desiredNumberOfLeadingZeros !== undefined) {
    if (!isValidNumber(desiredNumberOfLeadingZeros, { isRequiredToBeInteger: true, isRequiredToBeGreaterThanZero: true })) {
      throw new Error(`Unable to format number - desiredNumberOfLeadingZeros argument is not valid: ${typeof desiredNumberOfLeadingZeros}, ${desiredNumberOfLeadingZeros}.`);
    }

    shouldInsertCommas = false;

    let numberOfNonDecimals = stringNumber.indexOf('.');

    if (numberOfNonDecimals === -1) {
      numberOfNonDecimals = stringNumber.length;
    }

    const numberOfAdditionalLeadingZerosNecessary = Math.max(Number(desiredNumberOfLeadingZeros) - numberOfNonDecimals, 0);

    for (let i = 0; i < numberOfAdditionalLeadingZerosNecessary; i++) {
      stringNumber = `0${stringNumber}`;
    }
  }

  if (shouldInsertCommas) {
    // stringNumber = '2314.54'
    let i = stringNumber.indexOf('.');// i = 4

    if (i === -1) {
      i = stringNumber.length;
    }

    i = Math.max(0, i - 3); // i = 1
    let newStringNumber = stringNumber.slice(i); // newStringNumber = '314.54'

    while (i > 0) {
      const nextIndex = Math.max(0, i - 3); // nextIndex = 0
      newStringNumber = `${stringNumber.slice(nextIndex, i)},${newStringNumber}`; // newStringNumber = '
      i = nextIndex;
    }

    stringNumber = newStringNumber;
  }

  if (isNegative) {
    stringNumber = `-${stringNumber}`;
  }

  if (options.includeSign && !isNegative) {
    stringNumber = `+${stringNumber}`;
  }

  return stringNumber;
}
